import { render } from "./SupersetCard.vue?vue&type=template&id=2d78d61e"
import script from "./SupersetCard.vue?vue&type=script&lang=js"
export * from "./SupersetCard.vue?vue&type=script&lang=js"

import "./SupersetCard.vue?vue&type=style&index=0&id=2d78d61e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__